import assetPath from '/opt/actions-runner/_work/crate/crate/xinglets/startpage-logged-out/entry/src/companies-section/assets/rewe-photo.webp';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')